import useMarketingOptIn, { MarketingOptInResults } from '@tock/shared/hooks/useMarketingOptIn';

interface WithMarketingOptIn {
  showSoftOptInCheckbox: boolean;
}

// Create the HoC
export function withMarketingOptIn<T>(
  WrappedComponent: React.ComponentType<T & WithMarketingOptIn & MarketingOptInResults>
) {
  // Functional component that uses the hook and passes the data to the class component
  const WithDataPrivacy = (props: T) => {
    return <WrappedComponent {...props} {...useMarketingOptIn()} />;
  };

  return WithDataPrivacy;
}

export default (): MarketingOptInResults => {
  return useMarketingOptIn({ inChaseUR: false });
};
